module.exports = __webpack_public_path__ + "static/Recruit00-2c778b49cb0cc23624f786dd8bc581ad.png";